<template>
  <div>
      <v-btn color="primary darken-1" @click="$router.go(-2)" class="d-print-none">
          <v-icon left>mdi-arrow-left-bold-circle-outline</v-icon>
          Back
      </v-btn>
      <v-card outlined elevation="1" id="print">
          <!-- /print card ------------->
          <v-card class="d-flex justify-center mt-4" flat tile>
              <v-card-title class="subtitle-2 font-weight-bold">Receipt No: {{ afft_data.receipt_no }} </v-card-title>
          </v-card>
          <!-- /1 row ------------->

          <v-card class="d-flex justify-space-between mx-10 mt-n5 d-print-flex" flat tile>
              <v-card flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Form No: {{ afft_data.display_admission_form_no }} </v-card-title>
              </v-card>
              <v-card flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Receipt Date: {{ afft_data.receipt_date }} </v-card-title>
              </v-card>
          </v-card>
          <!-- /2 row ------------->

          <v-card class="d-flex justify-center mt-n5" flat tile>
              <v-card-title class="body-2 font-weight-normal">Recieved with thanks application form fees for the admission year {{ afft_data.admissionyear }} form</v-card-title>
          </v-card>
          <!-- /3 row ------------->

          <v-card class="d-flex justify-center mt-n4" flat tile>
              <v-card-title class="subtitle-2 font-weight-bold">{{ afft_data.name }} </v-card-title>
          </v-card>
          <!-- /4 row ------------->

          <v-card class="d-flex justify-space-between mx-10" flat tile>
              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Sr No </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">1</v-card-title>
              </v-card>

              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Perticulars of the fees </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">Application Form Fees</v-card-title>
              </v-card>

              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Amount(Rs.)</v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">{{ afft_data.amount }}</v-card-title>
              </v-card>
          </v-card>
          <!-- /5 row ------------->

          <v-card class="d-flex justify-center" flat tile>
              <v-card-title class="subtitle-2 font-weight-bold">Amounts in words: {{ afft_data.amount_in_words }} </v-card-title>
          </v-card>
          <!-- /6 row ------------->
          <v-card class="d-flex justify-space-between mx-10 mt-6 mb-6 d-print-flex" flat tile>
              <v-card flat tile class="ml-12">
                  <v-card-title class="subtitle-2 font-weight-bold">Seal </v-card-title>
              </v-card>
              <v-card flat tile class="mr-12">
                  <v-card-title class="subtitle-2 font-weight-bold">Signature of Reciever </v-card-title>
              </v-card>
          </v-card>
          <!-- /6 row ------------->

          <v-card class="d-flex justify-space-between mx-10" flat tile>
              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Payment Mode </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">{{ afft_data.paymentmode }}</v-card-title>
              </v-card>

              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">DD No./Cheque No./Transaction No. </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">{{ afft_data.transaction_number }}</v-card-title>
              </v-card>

              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Date </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">{{ afft_data.drawn_date }}</v-card-title>
              </v-card>

              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Amount(Rs.) </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">{{ afft_data.amount }}</v-card-title>
              </v-card>

              <v-card d-flex flex-column flat tile>
                  <v-card-title class="subtitle-2 font-weight-bold">Drawn On </v-card-title>
                  <v-card-title class="body-2 font-weight-normal mt-n6">{{ afft_data.bank }}</v-card-title>
              </v-card>
          </v-card>
          <!-- /8 row ------------->

          <v-card class="d-flex justify-end mr-10 mb-4 mt-4" flat tile>
              <v-btn class="ma-2 d-print-none" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
          </v-card>
          <!--{{ afft_data }} -->
      </v-card>
      <!-- /.end of print card ------------->
      <!-- <v-card class="box" v-if="defaultValues!=null">
          <v-col cols="12" sm="12" md="12" class="mr-5 pr-5"> <div  v-html="defaultValues"></div> </v-col>
        </v-card> -->
  </div>
</template>
<script>
  import axios from "axios";
  export default {
      data: () => ({
          afft_id: null,
          afft_data: null,
          defaultValues:null,
      }),
      mounted() {
          this.afft_id = this.$store.getters.form_fees_trans_id;
          if (this.afft_id == null || this.afft_id == "") {
              this.$router.go(-2);
              return;
          }
          const formData = {
              afft_id: this.afft_id,
          };
          axios
              .post("/account/formFeesReceipt", formData)
              .then((res) => {
                  if (res.data.msg == "200") {
                      if (res.data.status == "NO") {
                          alert(res.data.status_reason);
                      } else {
                          this.afft_data = res.data.afft_data;
                          this.defaultValues = res.data.defaultValues
                      }
                  }
              })
              .catch((error) => {
                  window.console.log(error);
              })
              .finally(() => {
                  //close loader
              });
      },

      methods: {
          print() {
              window.print();
          },
      },
  };
</script>
<style scoped>
  @media print {
      body {
          height: 100%;
          width: 100%;
      }
      .no-display {
          display: none !important;
      }
      .d-flex {
          margin: 1% !important;
      }
      #print * {
          visibility: visible;
      }
      @page {
          /* size: A4;
  margin: 0px; */
          /* size: 15in 11in; */
          size: A4;
          margin-top: none !important;
          padding-top: none;
          size: 15in 11in;
      }
  }
</style>
